import navigation from '../../config/navigation'

export enum SidebarSection {
  PROJECTS = 'projects',
  RECRUITMENT = 'recruitment',
  ADMINISTRATION = 'administration',
  PERSONAL = 'personal',
  RESOURCING = 'resourcing',
  MAIN = 'main',
}

type SectionMatcher = {
  section: SidebarSection
  matcher: (pathname: string) => boolean
}

const matchesPath = (pathname: string, path: string) => pathname === path || pathname.startsWith(path + '/')
const includesAny = (pathname: string, paths: string[]) => paths.some(path => matchesPath(pathname, path))

const sidebarSectionMatchers: SectionMatcher[] = [
  {
    section: SidebarSection.PROJECTS,
    matcher: pathname => includesAny(pathname, [navigation.projects, navigation.reports]),
  },
  {
    section: SidebarSection.RECRUITMENT,
    matcher: pathname => pathname.includes(navigation.candidates),
  },
  {
    section: SidebarSection.ADMINISTRATION,
    matcher: pathname =>
      includesAny(pathname, [navigation.users, navigation.techStack, navigation.demands, navigation.general]),
  },
  {
    section: SidebarSection.PERSONAL,
    matcher: pathname => pathname.includes(navigation.myProfile),
  },
  {
    section: SidebarSection.RESOURCING,
    matcher: pathname => includesAny(pathname, [navigation.projectsDistribution, navigation.settlements]),
  },
  {
    section: SidebarSection.MAIN,
    matcher: pathname =>
      includesAny(pathname, [
        navigation.home,
        navigation.schedule,
        navigation.worklog,
        navigation.vacation,
        navigation.yearlySummary,
      ]),
  },
]

export const getSidebarSectionFromPath = (pathname: string): SidebarSection | null => {
  const match = sidebarSectionMatchers.find(({ matcher }) => matcher(pathname))
  return match?.section ?? null
}
